/* Tall recommendation columns must remain reachable through normal page scrolling. */
(() => {
  if (customElements.get('ag-related-stack')) return;
  customElements.define('ag-related-stack', class extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('[data-ag-related-gifts]')) return;
      this.events = new AbortController();
      const root = this.closest('[data-ag-pdp-purchase]');
      this.update = () => {
        const desktop = matchMedia('(min-width:768px)').matches;
        const height = window.visualViewport?.height || innerHeight;
        this.classList.toggle('is-tall', desktop && this.getBoundingClientRect().height > height - 60);
      };
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this);
      addEventListener('resize', this.update, {signal:this.events.signal});
      window.visualViewport?.addEventListener('resize', this.update, {signal:this.events.signal});
      // Shopify can change the shared-scroll flag without replacing every descendant.
      this.attributesObserver = new MutationObserver(this.update);
      if (root) this.attributesObserver.observe(root, {attributes:true,attributeFilter:['data-ag-desktop-scroll']});
      this.update();
    }
    disconnectedCallback() {
      this.events?.abort(); this.observer?.disconnect(); this.attributesObserver?.disconnect();
    }
  });
})();
